export const LAST_SKELETON_VALUE_MARGIN_BOTTOM = 4;
export const ITEM_MARGIN_HEIGHT = 16; // keep in sync with Tile's marginBlockStart
export const TILE_MARGIN_BOTTOM = 12; // Keep in sync with Tile's marginBlockEnd
export const TILE_PADDING = 16; // Keep in sync with Tile's paddingBlockStart
export const TILE_BORDER = 2; // Keep in sync with Tile's borderWidth